<div class="cards-filter">
  <div class="filter-header">
    <h3 class="filter-title">Filtrar Regras de Recorrência</h3>
    <div class="filter-count">{{ filteredCount() }} de {{ totalCount() }} itens</div>
  </div>

  <div class="filter-sections">
    <div class="filter-section">
      <h4 class="section-title">Status</h4>
      <visio-multi-select
        [options]="activeOptions"
        (changeSelected)="toggleActiveFilterStatus($event)"
        [placeholder]="'Status'"
      >
      </visio-multi-select>
    </div>

    <div class="filter-section">
      <h4 class="section-title">Estabelecimentos</h4>
      <visio-multi-select
        [options]="shopIdsOptions()"
        (changeSelected)="toggleShopIdsFilterStatus($event)"
        [placeholder]="'Estabelecimentos'"
      >
      </visio-multi-select>
    </div>

    <div class="filter-section">
      <h4 class="section-title">CS Responsável</h4>
      <visio-multi-select
        [options]="userIdsOptions()"
        (changeSelected)="toggleUserIdsFilterStatus($event)"
        [placeholder]="'CS Responsável'"
      >
      </visio-multi-select>
    </div>

    <div class="filter-section">
      <h4 class="section-title">Produtos</h4>
      <visio-multi-select
        [options]="productsOptions"
        (changeSelected)="toggleProductsFilterStatus($event)"
        [placeholder]="'Produtos'"
      >
      </visio-multi-select>
    </div>
  </div>
</div>
